// Copyright (c) 2020 Comsearch, Inc., All rights reserved

import React from "react";
import { number, string } from "prop-types";
import useGeneratingMessageForFinalizationMailingList from "./hooks/useGeneratingMessageForFinalizationMailingList";

const GeneratingMessageForFinalizationMailingList = ({
  exportJobId,
  initialJobStatus,
  uid,
}) => {
  const jobStatus = useGeneratingMessageForFinalizationMailingList(
    exportJobId,
    initialJobStatus,
    uid
  );

  return <p className={"padding-bottom-1"}>{jobStatus}</p>;
};

GeneratingMessageForFinalizationMailingList.propTypes = {
  exportJobId: number.isRequired,
  initialJobStatus: string.isRequired,
  uid: string.isRequired,
};

export default GeneratingMessageForFinalizationMailingList;
